var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.conf
    ? _c(
        "div",
        {
          staticClass: "tpl-ticket",
          style: { backgroundColor: _vm.conf.background_color },
        },
        [
          _c("TransparentHeader", {
            attrs: {
              scrollHeight: 100,
              color: _vm.conf.background_color,
              titleColor: "#FFFFFF",
              titleCustomOpacity: 1,
            },
          }),
          _c("div", [
            _vm.conf.top_img
              ? _c("img", {
                  staticClass: "top-img",
                  attrs: { src: _vm.conf.top_img, alt: "" },
                })
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "ticket-info",
                style: { backgroundImage: `url(${_vm.conf.coupon_img})` },
                on: { click: _vm.couponClick },
              },
              [
                _c("div", { staticClass: "range-coupon" }, [
                  _c("div", { staticClass: "text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.received ? "立即使用" : "立即领取")
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "button-phone" }, [
                  _vm.conf.button_img && _vm.conf.org_id
                    ? _c("img", {
                        staticClass: "button-img",
                        attrs: { src: _vm.conf.button_img, alt: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.jumpMiniProgram.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "change-phone",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.changeMobileClick.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" 更换手机号领取 ")]
                  ),
                ]),
              ]
            ),
            _vm.conf.remark
              ? _c("div", {
                  staticClass: "explain-info",
                  domProps: { innerHTML: _vm._s(_vm.conf.remark) },
                })
              : _vm._e(),
          ]),
          _c(
            "van-dialog",
            {
              attrs: { title: "", showConfirmButton: false },
              model: {
                value: _vm.changeMobileModelShow,
                callback: function ($$v) {
                  _vm.changeMobileModelShow = $$v
                },
                expression: "changeMobileModelShow",
              },
            },
            [
              _c("div", { staticClass: "dialog-wrap" }, [
                _c("li", { staticClass: "title" }, [_vm._v("更换手机号领取")]),
                _c("div", [
                  _c("li", { staticClass: "label" }, [_vm._v("领取手机号")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phone,
                        expression: "phone",
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "number" },
                    domProps: { value: _vm.phone },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.phone = $event.target.value
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "btn", on: { click: _vm.confirmReceive } },
                  [_vm._v(" 确认领取 ")]
                ),
              ]),
              _c("img", {
                staticClass: "dialog-close",
                attrs: {
                  src: require("../../../assets/img/202305/tpl-ticket/close.png"),
                  alt: "",
                },
                on: {
                  click: function ($event) {
                    _vm.changeMobileModelShow = false
                  },
                },
              }),
            ]
          ),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "loading-wrap" },
        [_c("van-loading", [_vm._v("加载中...")])],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }